import React, { useMemo } from "react";
import { getNodeToColorMapping, getNodeDataFromNodeMapping, DEFAULT_SILO_BUSTING_CHART_DATA } from "./utils";
import DependencyWheel from "../../Reports/templates/DependencyWheel";
import TopAreasOfConnection from "./TopAreasOfConnection";
import i18n from '../../../../utils/ChrI18n';
import { exportEventName } from './';

const SiloBustingChart = ({chartComponentData = DEFAULT_SILO_BUSTING_CHART_DATA}) => {
  const { chart_data = [], choice_id_to_text_mapping = {}, can_show_chart_description_note } = chartComponentData;
  
  const chartData = useMemo(() => {
    return chart_data.map(([fromId, toId, weight]) => [choice_id_to_text_mapping[fromId], choice_id_to_text_mapping[toId], weight]);
  }, [chart_data, choice_id_to_text_mapping]);
  
  const nodeColors = getNodeToColorMapping(chartData);
  const nodeColorData = getNodeDataFromNodeMapping(nodeColors);
  
  const handleExportData = (exportPayload) => {
    // Remove the first column (auto-generated category IDs) from CSV export
    exportPayload.dataRows.forEach((dataRow) => dataRow.shift());
    
    // Update default header names
    exportPayload.dataRows[0] = [
      i18n.t('widgets.silo_busting.csv_header.choice_one'),
      i18n.t('widgets.silo_busting.csv_header.choice_two'),
      i18n.t('widgets.silo_busting.csv_header.connection_count', jsConstants.customTerms)
    ];
  };
  
  return (
    <div className="cui_silo_busting_chart flex-grow-2 b-r-8 p-20 cui-custom-bg-secondary">
      <div className="d-flex flex-gap-70 flex-column flex-md-row justify-content-center align-items-center h-100">
        {chart_data.length === 0 ? (
          <div className="font-16 text-muted">{i18n.t('common_text.info.No_data_available')}</div>
        ) : (
          <>
            <div className="align-items-center d-flex flex-column">
              <DependencyWheel
                chartOptions={{
                  series: [{
                    keys: ['from', 'to', 'weight'],
                    data: chartData,
                    nodes: nodeColorData
                  }]
                }}
                backgroundColor="var(--background-secondary)"
                configs={{export: true, exportEventName}}
                exportData={handleExportData}
              />
              {can_show_chart_description_note && (
                <div className="font-12 text-muted">
                  {i18n.t('widgets.silo_busting.chart_description', jsConstants.customTerms)}
                </div>
              )}
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center ml-24">
              <TopAreasOfConnection chartComponentData={chartComponentData} nodeColors={nodeColors} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SiloBustingChart;